import ProgressBar from "@pathwright/ui/src/components/progress/ProgressBar"
import "./MemberInlineStats.css"

const MemberInlineStats = (props) => {
  const { member } = props
  const { points, progress } = member

  // const pointsLabel = `${Math.floor(points.percentage)}%`
  const pointsLabel = points.earned

  return (
    <div className="MemberInlineStats">
      <div className="MemberInlineStats__stats">
        <div className="MemberInlineStats__wrapper">
          <div className="MemberInlineStats__progress">
            <ProgressBar
              fillColor="forestgreen"
              progress={progress}
              height={7}
            />
          </div>
          <div className="MemberInlineStats__complete">
            <label>{Math.floor(progress * 100)}%</label>
            <span>complete</span>
          </div>
        </div>
        {points.available > 0 && <div className="MemberInlineStats__divider" />}
        {points.available > 0 && (
          <div className="MemberInlineStats__points">
            <label>{pointsLabel}</label>
            <span>pts</span>
          </div>
        )}
      </div>
    </div>
  )
}

MemberInlineStats.displayName = "MemberInlineStats"

export default MemberInlineStats
